<template>
  <el-date-picker style="border: 1px solid #FFCC00;" class="separator_time "
                  v-model="pickerTime" type="daterange" @change="pickerTime_change"
                  range-separator="~" value-format="yyyy-MM-dd" format="yyyy-MM-dd" start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  prefix-icon=" "
                  @focus="handleFocus"
  >
  </el-date-picker>
</template>

<script>

let startTime = ''
export default {
  props: {
    pickerTime: {
      type: Array,
      default: () => []  // 注意：应该使用函数返回默认值
    },
  },
  data() {
    return {
      localTime: [],


      pickerOptions: {
        onPick: ({maxDate, minDate}) => {
          if (minDate) {
            startTime = minDate.getTime()
          } else {
            startTime = ''
          }
        },
        disabledDate(time) {
          if (startTime != '') {
            const oneMonth = 30 * 24 * 3600 * 1000;
            const minTime = startTime - oneMonth;
            const maxTime = startTime + oneMonth;

            return time.getTime() < minTime || time.getTime() > maxTime|| time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
    }
  },
  methods: {
    pickerTime_change(t) {
      this.$emit('update:pickerTime', t);
      this.$parent.pickerTime_change(t[0], t[1])
    },
    handleFocus(){
      startTime = ''
    },
  },
  // 组件销毁前重置 startTime
  beforeDestroy() {
    startTime = '';
  },
}
</script>

<style scoped lang="scss">

.separator_time {
  font-weight: 400;
  font-size: 22px;
  color: #00A8FF !important;
  width: 348px;
  height: 39px;
  background: #0f2953 !important;
  border: 1px solid #0C70A4;
}

::v-deep  .el-range-input{
  color: #FFCC00 !important;
}

::v-deep  .el-range-separator{
  color: #FFCC00 !important;
}


.el-range-editor.el-input__inner {
  border-radius: 10px !important;
}

</style>